import React from 'react';

import Button from '@atlaskit/button/new';

const ButtonSubtleExample = (): React.JSX.Element => {
	return <Button appearance="subtle">Subtle button</Button>;
};

export default ButtonSubtleExample;
